import React from "react";

const DetailedReviewLightBoxSkeleton = () => {
    return (
        <div className="review-comments-card p-[16px] grow">
            <div className="review-comments flex flex-col gap-[24px]">
                <div className="review-comments__col w-full">
                    <div className="flex items-center gap-[16px]">
                        <div className="reviewer__avatar flex items-center justify-center min-w-[80px] w-[80px] h-[80px] bg-neutral-100 text-heading4 font-bold uppercase rounded-[80px]">
                        </div>
                        <div className="flex flex-col basis-[200px] *:text-x-small *:text-grey300 *:text-left">
                            <div className="skeleton skeleton-text-animated descrip"></div>
                            <div className="skeleton skeleton-text-animated descrip"></div>
                            <div className="skeleton skeleton-text-animated descrip"></div>
                        </div>

                    </div>
                </div>
                <div className="review-comments__col flex-1">
                    <div className="flex flex-col flex-1 gap-[24px]">
                        <div className="flex flex-col flex-1 *:text-grey300">
                            <div className="skeleton skeleton-text-animated descrip !w-[30%]"></div>
                            <div className="flex flex-col gap-[4px]">
                                <div className="skeleton skeleton-text-animated large_heading !w-[50%]"></div>
                                <div className="skeleton skeleton-text-animated heading !w-[65%]"></div>
                            </div>
                        </div>
                        <div className="review-body flex flex-col gap-[16px]">
                            <div className="flex flex-col gap-[20px]">
                                {/* -- loop */}
                                <div className="flex flex-col gap-[8px]">
                                    <div className="category-rank flex items-center gap-[8px]">
                                        <span className="skeleton skeleton-text-animated heading !w-[20%] !m-0"></span>
                                        <div className="flex gap-[4px] items-center">
                                            <div className="flex gap-[4px]">
                                                {[1].map((_, starIdx: number) => <svg
                                                    key={starIdx}
                                                    width="18"
                                                    height="18"
                                                    viewBox="0 0 18 18"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M7.85874 1.14803C8.21796 0.0424542 9.78205 0.0424547 10.1413 1.14803L11.4248 5.09818C11.5854 5.59261 12.0462 5.92736 12.566 5.92736H16.7195C17.8819 5.92736 18.3653 7.4149 17.4248 8.09818L14.0646 10.5395C13.644 10.8451 13.468 11.3867 13.6287 11.8812L14.9122 15.8313C15.2714 16.9369 14.006 17.8562 13.0656 17.173L9.70535 14.7316C9.28477 14.426 8.71525 14.426 8.29466 14.7316L4.93446 17.173C3.994 17.8562 2.72863 16.9369 3.08785 15.8313L4.37133 11.8812C4.53198 11.3867 4.35599 10.8451 3.93541 10.5395L0.575205 8.09818C-0.365252 7.4149 0.118079 5.92736 1.28055 5.92736H5.43399C5.95386 5.92736 6.41461 5.59261 6.57525 5.09818L7.85874 1.14803Z"
                                                        fill="#E2E8F0"
                                                    />
                                                </svg>)}

                                            </div>

                                        </div>
                                    </div>
                                    <div className="skeleton skeleton-text-animated descrip !w-[15%]"></div>
                                    <div className="skeleton skeleton-text-animated descrip !m-0"></div>
                                    <div className="skeleton skeleton-text-animated descrip !m-0"></div>
                                    <div className="skeleton skeleton-text-animated descrip !m-0"></div>
                                    <div className="skeleton skeleton-text-animated descrip !m-0"></div>
                                    <div className="flex flex-wrap gap-x-[16px] gap-y-[2px] *:text-small *:text-grey300 *:font-semibold w-full md:w-[375px] bg-grey-100 p-[16px] rounded-[8px]">
                                        <div className="skeleton skeleton-text-animated small-heading !m-0"></div>
                                        <div className="skeleton skeleton-text-animated small-heading !m-0"></div>
                                        <div className="skeleton skeleton-text-animated small-heading !m-0"></div>
                                        <div className="skeleton skeleton-text-animated small-heading !m-0"></div>
                                        <div className="skeleton skeleton-text-animated small-heading !m-0"></div>
                                    </div>
                                </div>
                                {/* -- loop */}

                                {/* <div className='w-fit cursor-pointer underline'>- Read less</div>     */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DetailedReviewLightBoxSkeleton;
